var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPacketLossIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.5l1.5 1.5 5-5-5-5L13 4.5 16.5 8 13 11.5zM7 4.5L5.5 3l-5 5 5 5L7 11.5 3.5 8 7 4.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8a1 1 0 11-2 0 1 1 0 012 0zM11 8a1 1 0 11-2 0 1 1 0 012 0zM14 8a1 1 0 11-2 0 1 1 0 012 0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacketLossIcon);
export default __webpack_public_path__ + "static/media/packet_loss-icon.508082abb54685a3c6560917fb7f0453.svg";
export { ForwardRef as ReactComponent };